import Localization from '../config/localization';

export function GetErrorCode(error: Error.IError) {
  return error.code || error.status || error.statusCode || 0;
}

export function GetErrorMessageByCode(errorCode: number | string = '') {
  return Localization.Errors[errorCode as keyof Error.IApiError] || Localization.Errors.default;
}

export function GetError(error: Error.IError) {
  const code = GetErrorCode(error);

  return {
    code,
    message: GetErrorMessageByCode(code)
  };
}

export class CustomError extends Error {
  code?: string | number;

  constructor(message = Localization.Errors.default, code = 'default') {
    super(message);
    this.code = code;
  }
}
